import useDrawer from 'hooks/useDrawer/useDrawer';
import React from 'react';
import UIDrawer from 'ui/atoms/Drawer/Drawer';
import AccessApp from './variants/accessApp/accessApp';
import AccessEventsFilters from './variants/accessEvents/AccessEventsFilters/AccessEventsFilters';
import EditApiKey from './variants/apiKey/EditApiKey';
import AddExternalMember from './variants/externalMembers/AddExternalMemberVariant';
import EditExternalMember from './variants/externalMembers/EditExternalMemberVariant';
import AddExternalUserGroup from './variants/externalUserGroup/AddExternalUserGroupVariant';
import EditExternalUserGroup from './variants/externalUserGroup/EditExternalUserGroupVariant';
import AddInstaller from './variants/installer/AddInstallerVariant';
import EditInstaller from './variants/installer/EditInstallerVariant';
import EditLock from './variants/locks/EditLock/EditLock';
import ManageLockGroups from './variants/locks/ManageLockGroups/ManageLockGroups';

const Drawer: React.FC<React.PropsWithChildren> = () => {
  const { hideDrawer, drawerState } = useDrawer();

  const handleDrawerClose = () => hideDrawer();

  const renderCorrectVariant = () => {
    switch (drawerState?.type) {
      case 'editLock':
        return <EditLock />;
      case 'accessEventsFilters':
        return <AccessEventsFilters />;
      case 'myProfile':
        return <AccessApp />;
      case 'editExternalUser':
        return <EditExternalMember />;
      case 'addExternalUser':
        return <AddExternalMember />;
      case 'addExternalUserGroup':
        return <AddExternalUserGroup />;
      case 'editExternalUserGroup':
        return <EditExternalUserGroup />;
      case 'addInstaller':
        return <AddInstaller />;
      case 'editInstaller':
        return <EditInstaller />;
      case 'manageLockGroups':
        return <ManageLockGroups />;
      case 'editApiKey':
        return <EditApiKey />;
      default:
        return null;
    }
  };

  return (
    <UIDrawer
      open={Boolean(drawerState)}
      onClose={handleDrawerClose}
      onKeyDown={(event) => event.stopPropagation()}
      disableEscapeKeyDown
    >
      {renderCorrectVariant()}
    </UIDrawer>
  );
};

export default Drawer;
